import moment from "moment";
var ServiceListing = require('../Service/ServiceListing').ServiceListing;
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { MapContainer, TileLayer, Marker, AttributionControl, Popup } from 'react-leaflet';
import L from 'leaflet';
import { generateUptime, secondsToReadableTime, generateRuntime } from "../../Helper"
import { useState, useRef, useEffect  } from "react";
import ReactTooltip from 'react-tooltip'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { AbconetApi } from "../General/AbconetApi";

const c = [
    { x: 100, y: 200, z: 200 },
    { x: 120, y: 100, z: 260 },
    { x: 170, y: 300, z: 400 },
    { x: 140, y: 250, z: 280 },
    { x: 150, y: 400, z: 500 },
    { x: 110, y: 280, z: 200 },
];


const YouTubeEmbed = ({ url }) => {
    if (!url) {
        return null;
    }

    let videoId = "";
    if (url.includes('youtu.be/')) {
        // For shortened URLs in the format "https://youtu.be/[videoId]"
        videoId = url.split('youtu.be/')[1] || "";
    } else if (url.includes('watch?v=')) {
        // For full URLs in the format "https://www.youtube.com/watch?v=[videoId]"
        videoId = (url.split("v=")[1] || "").split("&")[0] || "";
    }

    if (!videoId) {
        return null;
    }

    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <iframe
            width="100%"
            height="100%"
            src={embedUrl}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        ></iframe>
    );
};

function getBatteryDays(batteryCollection) {
    return batteryCollection.filter(x => x.minBatteryCharge <= 20).length;
}

const NextService = ({ serviceCollection, bookNowLink }) => {
    var futureServiceCollection = [];

    if (serviceCollection) {
        futureServiceCollection = serviceCollection.filter((service) => {
            return service.workflowStatus != 'Closed' && service.workflowStatus != 'Resolved';
        });
    }

    if (futureServiceCollection.length > 0) {
        return moment(futureServiceCollection[0].startDate).format("YYYY-MM-DD");
    } else {
        return <a href={bookNowLink}>Book Now</a>;
    }
}


const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="recharts-default-tooltip" style={{ background: 'white', border: '1px solid #ccc', padding: '10px' }}>
                <p className="label"><strong>Day:</strong> {moment(payload[0].payload.Date).format("DD/MM/YYYY")}</p>
                <p className="intro" style={{marginBottom: 0, paddingBottom: 0}}><strong>Battery:</strong> {payload[0].value}%</p>
            </div>
        );
    }

    return null;
};



export class EquipmentView extends React.Component {i
    constructor(props) {
        super(props);
        
        var showField = true;
        var canEdit = true;
        var hireEquipment = '';

        if (!this.props.currentUser) {
            canEdit = false;
            showField = false;
        }

        if (this.props.currentUser != null && this.props.currentUser.accountId != this.props.initialState.accountId) {
            canEdit = false;
            showField = false;
        }

        if (this.props.initialState != null && this.props.initialState.accountId == 53658) {
            hireEquipment = 'Hire Equipment';
        }

        if (!this.props.initialState.canEdit) {
            canEdit = false;
        }

        this.state = {
            canEdit: canEdit,
            batteryIsOpen: false,
            showField: showField,
            hireEquipment: hireEquipment
        }


        this.processScanEvent(this.props.initialState);
    }

    processScanEvent(equipment) {

        var urlParams = new URLSearchParams(window.location.search);
        var hasScanParam = urlParams.has('scan');
        if (hasScanParam) {

            var latitude, longitude;
            if (navigator && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {

                    var data = {
                        equipmentId: equipment.id,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    };

                    console.log('Posting scan event', data);

                    AbconetApi
                        .post('/api/equipment/' + equipment.id + '/createScanEvent', data)
                        .then(() => {
                            console.log('Scan event created');
                        }).catch((error) => {
                            console.log(error);
                        });;
                },
                error => {
                    console.error('Error getting user location:', error);
                });
            }            
        }
    }

    setMap(data) {
        this.setState({
            mapRef: data
        });
    }

    renderEditButton() {
        if (this.state.canEdit) {
            return <button className="btn btn-lg btn-primary float-left btn-edit-template" onClick={this.setEditMode.bind(this)}>Edit</button>;
        }
    }

    setEditMode() {
        if (this.props.onSetEditMode) {
            this.props.onSetEditMode();
        }
    }

    closeBattery() {
        this.setState({ batteryIsOpen: false });
    }

    openBattery() {
        this.setState({ batteryIsOpen: true });
    }

    render() {
        var data = this.props.initialState;
        var installationDate = data.installationDate ? moment(data.installationDate) : null;
        var address = "";

        if (data.address) {
            address = data.address.name;

            if (address == null) {
                address = data.address.addressLine1;
            }
        }


        var position = data.lastKnownLocation ? [data.lastKnownLocation.lat, data.lastKnownLocation.lng] : null;

        var uptime = generateUptime(installationDate, data.serviceCollection);
        var runtime = generateRuntime(data.runtimeHistory, installationDate);


        function renderUptimeRow(name, uptime, runtime, includeRunTime = false, utilization) {
            var col = "col-6 ";
            if (includeRunTime) {
                col = "col-4 ";
            }
            var returnData = [
                <div className={col + " detail-header col-hd"}><strong>{name}:</strong></div>,
                <div className={col + "pl-0"}>
                    <div className="progress" style={{ height: "20px" }}>
                        <div className="progress-bar bg-secondary" role="progressbar" style={{ width: uptime + '%' }} aria-valuenow={uptime.allTime} aria-valuemin="0" aria-valuemax="100">{
                            uptime}%</div>
                        <div className="progress-bar bg-danger" role="progressbar" style={{ width: (100 - uptime) + '%' }} aria-valuenow={100-uptime.allTime} aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
                
            ];
            
            if (includeRunTime) {
                returnData.push(<div className="col-4 pl-0 text-center ">

                    <div className="progress" style={{ height: "20px", backgroundColor: '#999999' }} >
                        <div className="progress-bar bg-secondary" role="progressbar" style={{ width: utilization + '%' }} aria-valuenow={utilization} aria-valuemin="0" aria-valuemax="100"></div>

                        <small className="justify-content-center position-absolute w-100" style={{
                            left: '-5px',
                            top: '1px',
                            fontSize: '0.75rem',
                            color: '#fff'
                        }}>{utilization}% {runtime}</small>

                    </div>

                                    
                                </div>);
            }
            
            return returnData;
        }

        var includeRuntime = data.runtimeHistory.length > 0;
        var hasServiceCollection = data.serviceCollection != null && data.serviceCollection.length > 0;
        var self = this;

        var chartData = [];

        data.batteryHistory.forEach((batteryCharge) => {

            if (batteryCharge.minBatteryCharge > 0 && batteryCharge.minBatteryCharge <= 100) {
                chartData.push({
                    Date: moment(batteryCharge.date).format('L'), "Battery Percentage": batteryCharge.minBatteryCharge,
                });
            }
        });

        data.batteryHistory.sort((a, b) => {
            return a.dayNum - b.dayNum;
        });

        return (
            <div className="equipment-details">
                <div className="row">
                    <div className="col-lg-4 card card-body bg-light col-12">
                        <h4>Serial Number: {data.serialNumber}</h4>
                        {this.state.hireEquipment && <div><span>This is a hire equipment.</span></div>}
                        <div className="row mt-3">
                            {this.state.showField && <div className="col-6 detail-header"><strong>Site:</strong></div>}
                            {this.state.showField && <div className="col-6">{address}</div>}
                            <div className="col-6 detail-header"><strong>Equipment Type:</strong></div>
                            <div className="col-6">{data.equipmentType && data.equipmentType.name}</div>
                            <div className="col-6 detail-header"><strong>Make:</strong></div>
                            <div className="col-6">{data.make}</div>
                            <div className="col-6 detail-header"><strong>Model:</strong></div>
                            <div className="col-6">{data.model}</div>
                            {this.state.showField && <div className="col-6 detail-header"><strong>Installation Date:</strong></div>}
                            {this.state.showField && <div className="col-6">{installationDate && installationDate.format("DD/MM/YYYY")}</div>}
                            {data.batteryHistory.length > 0 && <div className="col-6 detail-header"><strong>Battery:</strong></div>}
                            {data.batteryHistory.length > 0 && <div className="col-6"><a href="#" onClick={this.openBattery.bind(this)}>{getBatteryDays(data.batteryHistory)} days under 20%</a></div>}
                            {this.state.showField && <div className="col-6 detail-header"><strong>Next Service:</strong></div>}
                            {this.state.showField && this.props.initialState.canEdit && <div className="col-6"><NextService serviceCollection={data.serviceCollection} bookNowLink={`/services/create/${data.id}`}/></div>}                            
                        </div>

                        {this.state.showField && <div>
                            <h4>History</h4>
                            <div className="row">
                                <div className={(includeRuntime ? "col-4" : "col-6") + " col-hd"}></div>
                                <div className={(includeRuntime ? "col-4" : "col-6") + " text-center col-hd pl-0"}><strong>Uptime</strong><i className="icon icon-info" data-tip='The duration of equipment availability, excluding time spent on breakdown repairs. '></i></div>
                                {includeRuntime && <div className={"col-4 pl-0 text-center col-hd"}><strong>Utilization</strong><i className="icon icon-info" data-tip='Actual usage vs possible usage'></i></div>}
                                {renderUptimeRow("30 Days", uptime.days30, runtime.days30, includeRuntime, runtime.utilization30)}
                                {renderUptimeRow("90 Days", uptime.days90, runtime.days90, includeRuntime, runtime.utilization90)}
                                {renderUptimeRow("365 Days", uptime.days365, runtime.days365, includeRuntime, runtime.utilization365)}
                                {renderUptimeRow("All Time", uptime.allTime, runtime.allTime, includeRuntime, runtime.allTimeUtilization)}
                            </div>
                        </div>
                        }

                        {position && <MapContainer attributionControl={false} center={position} zoom={16} scrollWheelZoom={false} style={{ marginTop: "2rem" }}  whenCreated={this.setMap.bind(this)}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />

                            <CustomMarker
                                map={this.state.mapRef}
                                data={{
                                    position: position
                                }}
                            >
                                Last Located: {moment(data.lastKnownLocationDate).format("LLL")}
                                </CustomMarker>
                            <AttributionControl position="bottomright" prefix={false} />
                        </MapContainer>
                        }

                        {(chartData.length > 0 && this.state.batteryIsOpen ) && <div>
                            <div className="battery-overlay-blocker"></div>
                            <div className="battery-overlay">
                                <a href="#" onClick={this.closeBattery.bind(this)}><i className="icon icon-close px-3 lead" ></i></a>
                                <h4>Battery Usage</h4>
                                 <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    data={chartData}
                                    margin={{ top: 5, right: 5, left: 5, bottom: 50 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="date" />
                                    <YAxis unit="%" />
                                        <Tooltip content={<CustomTooltip />}  />
                                    <Line type="monotone" dataKey="Battery Percentage" stroke="#8884d8" activeDot={{ r: 8 }} />
                                </LineChart>

                        </ResponsiveContainer></div>
                            </div>
                        }

                        {this.renderEditButton()}
                    </div>

                    <div className="col-lg-8 service-history">
                        {((data.trainingVideoLink && data.trainingVideoLink != "") || data.fileCollection) && <div className="card card-body bg-white">
                            <h3>Training</h3>
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <ul className="list-unstyled">
                                        {data.fileCollection && data.fileCollection.map(file => {
                                            return <li>
                                                <a href={file.filename} target="_blank" className={"file file-" + file.extension}>
                                                    {file.docType}
                                                </a>

                                            </li>;
                                        })}
                                    </ul>
                                </div>
                                {(data.trainingVideoLink && data.trainingVideoLink != "") && <div className="col-12 col-lg-6 training-video-container"><YouTubeEmbed url={data.trainingVideoLink} /></div>}
                            </div>
                        </div>}

                        {this.state.showField && <div className="card card-body bg-white">
                            <h3>Service History</h3>
                            <div className="service-listing">
                                <div className="list-group">
                                    <div className="row header d-none d-lg-flex">
                                        <div className="col-2 col-hd text-left">Service Id</div>
                                        <div className="col-2 col-hd text-left">Lodged Date</div>
                                        <div className="col-2 col-hd text-left">Status</div>
                                        <div className="col-3 col-hd text-left">Type</div>
                                        <div className="col-3 col-hd text-left">Downtime</div>
                                    </div>
                                    {hasServiceCollection == 0 && <div>No Service History</div>}
                                    {hasServiceCollection && data.serviceCollection.map(function (service) {
                                        var startDate = service.startDate ? moment(service.startDate).format("DD/MM/YYYY") : "";
                                        var finished = service.dueDate ? moment(service.dueDate) : moment();
                                        var duration = moment.duration(finished.diff(service.startDate));

                                        return (
                                            <div className="item pl-0 pr-0" key={service.id}>
                                                <div className="row">
                                                    <div className="col-6 d-lg-none">
                                                        <strong>Service Id:</strong>
                                                    </div>
                                                    <div className="col-6 col-lg-2 text-left">
                                                        <a style={{ whiteSpace: 'nowrap' }} href={`/services/${service.id}`}>{service.name}</a>
                                                    </div>
                                                    <div className="col-6 d-lg-none">
                                                        <strong>Lodged Date:</strong>
                                                    </div>
                                                    <div className="col-6 col-lg-2 text-left" >
                                                        {startDate}
                                                    </div>
                                                    <div className="col-6 d-lg-none">
                                                        <strong>Status:</strong>
                                                    </div>
                                                    <div className="col-6 col-lg-2 text-left" >
                                                        {service.workflowStatus}
                                                    </div>
                                                    <div className="col-6 d-lg-none">
                                                        <strong>Type:</strong>
                                                    </div>
                                                    <div className="col-6 col-lg-3 text-left">
                                                        {service.serviceType}
                                                    </div>
                                                    <div className="col-6 d-lg-none">
                                                        <strong>Downtime:</strong>
                                                    </div>
                                                    <div className="col-6 col-lg-2 text-left" >
                                                        {service.serviceType === 'Breakdown' && duration.humanize()}
                                                        {service.serviceType !== 'Breakdown' && <text>N/A</text>}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                    
                </div>
                {this.state.showField && <a href="/equipment" className="btn btn-outline-primary">View all <span className="d-none d-lg-inline">Equipment</span></a>}
                {data.baseProduct && <a href={data.baseProduct.url} className="btn btn-primary ml-2">Order Parts</a>}
                {this.state.showField && this.props.initialState.canEdit && <a href={`/services/create/${this.props.initialState.id}`} className="btn btn-primary float-right book-service-button">Book service</a>}

                {this.props.currentUser == null && (<a href={`/login?redirect=${window.location.pathname}`} className="btn btn-primary float-right book-service-button">Login For More</a>)}

                <ReactTooltip />
            </div>
        );
    }

}


const CustomMarker = ({ data, map, children }) => {
    const [refReady, setRefReady] = useState(false);
    let popupRef = useRef();

    useEffect(() => {
        if (refReady ) {
            popupRef.openOn(map);
        }
    }, [refReady, map]);

    return (
        <Marker position={data.position}>
            <Popup
                ref={(r) => {
                    popupRef = r;
                    setRefReady(true);
                }}
            >
                {children}
            </Popup>
        </Marker>
    );
};